export default function() {
	var headerBlock = $('.header');
	const $slider =  $('.menu-mobile__list');
	let activeScreen = 0;
	let $currentScreen = $();

	$('.header__m-btn').on('click', function(){
		const $headerBtn = $(this).toggleClass('js-active');
		$('.header__m-menu').toggleClass('menu-mobile--active');
		$('body').toggleClass('js-modal-opened');

		$('.header-through-banner').fadeToggle(300).promise().done(()=>{
			if (!$headerBtn.hasClass('js-active')) {
				$slider.css("transform", 'translateX(0)');
				activeScreen = 0;
				$slider.find('.menu-mobile__screen:not(.menu-mobile__screen_start)').hide();
			}
		});
	});

	$('.header__m-search-icon').on('click', function(){
		$('.header__m-search').addClass('js-active');

	});

	var $floatingHeader = $('.header__floating');

	if ($floatingHeader.length > 0 && ResponsiveUtil.isDesktopUp()) {
		var startY = headerBlock.height();
		var floatingHeaderHeight = $floatingHeader.outerHeight() + 8;
		var isActive = window.pageYOffset > startY;

		$floatingHeader.toggleClass('header__floating--active', isActive);

		$(window).on('scroll', function(){
			isActive = window.pageYOffset > startY;
			$floatingHeader.toggleClass('header__floating--active', isActive);
			if (isActive) {
				headerBlock.css('padding-bottom', floatingHeaderHeight + 'px');
			} else {
				headerBlock.css('padding-bottom', 0);
			}

		});
	}

		$('.nav-item_btn').on('click', function () {
		const $itemBtn = $(this);
		const id = $itemBtn.data('id');
			if (id) {
				$currentScreen = $slider.find(`.menu-mobile__screen[data-id="${id}"]`).show();
				activeScreen++;
				$slider.css("transform", `translateX(${-activeScreen * 100}%)`);
			}
		})

		$('.menu-mobile__screen-btn').on('click', function () {
			activeScreen--;
			$slider.css("transform", `translateX(${-activeScreen * 100}%)`);
			setTimeout(()=>{
				if ($currentScreen.length) {
						$currentScreen.hide();
						$currentScreen = $(`.nav-item_btn[data-id="${$currentScreen.data('id')}"]`).closest('.menu-mobile__screen');
				}
			}, 300)
		})
}
